<template>
  <div class="student-intervention-level-wrapper">
    <section-title has-line title="Documentos" />

    <div
      v-for="(document, index) in documents"
      :key="index"
      class="row mx-0 mb-4 bg-gray p-4 rounded"
    >
      <div class="col-12 col-md-9">
        <label class="text-gray font-14">Documento:</label>
        <p class="font-16">
          {{ document.name }}
        </p>
      </div>
      <div class="col-12 col-md-3 mt-3">
        <div class="d-flex align-items-center">
          <validation-provider v-slot="{ errors }" mode="lazy" rules="required">
            <custom-file-input
              ref="fileUpload"
              display-style="normal"
              :value="document.file"
              @input="(file) => onSelectFile(file, document)"
              :on-download="downloadFile"
              :accept="'.pdf'"
              label-position="left"
              :error="errors[0]"
              custom-error-msg="El documento es requerido."
              :disabled="readonly"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12">
        <action-button
          type="button"
          text="Descargar Documento"
          i="fas fa-file-download"
          variant="outline-success"
          @click="downloadDocument(document.documentTypeId, 'pdf')"
        />
      </div>
    </div>
    <DocumentsForm
      ref="documentsFormRef"
      class="mt-3"
      :documents="additionalDocuments"
      :allowed-document-types="additionalDocumentTypes"
      :multiple-uploads-document-type-ids="[]"
      :has-existing-documents="documents.length > 0"
      :read-only="readonly"
      :show-title="false"
      :minute-document-type-id="documentTypesConstants.SAEE_Minute"
      :is-compu-minute-system-selection-enabled="isCompuMinuteSystemSelectionEnabled"
      :student-sie-id="studentSieId"
      :minute-info="minuteInfo"
      :on-go-to-draft-minute="onGoToDraftMinute"
      @minute-info-input="$emit('minute-info-input', $event)"
    />
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import DocumentsService from '@/services/documents';
import ActionButton from 'ActionButton';
import DocumentsForm from '@/views/humanResources/request/components/DocumentsForm';
import CompuMinuteSelection from '@/components/shared/CompuMinuteSelection.vue';
import documentTypesConstants from '@/utils/constants/documentTypes';

export default {
  name: 'ABADocumentation',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomFileInput,
    CustomInput,
    ActionButton,
    DocumentsForm,
    CompuMinuteSelection,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    additionalDocuments: {
      type: Array,
      default: () => [],
    },
    isCompuMinuteSystemSelectionEnabled: {
      type: Boolean,
      default: false,
    },
    studentSieId: {
      type: [Number, String],
      default: null,
    },
    minuteInfo: {
      type: Object,
      default: () => ({
        useSystemMinute: null,
        compuMinuteId: null,
        fileId: null,
        fileName: null,
      }),
    },
    onGoToDraftMinute: {
      type: Function,
      default: null,
    },
  },
  async mounted() {
    await this.getABAEvaluationDocuments();
  },
  data() {
    return {
      documentTypes: [],
      documentTypesConstants,
      additionalDocumentTypes: [
        {
          id: documentTypesConstants.SAEE_Minute,
          name: 'Minuta SAEE-08',
        },
      ],
      documents: [],
    };
  },
  computed: {
    hasMinuteAttached() {
      return (
        this.additionalDocuments.some(
          (document) => document.documentTypeId === documentTypesConstants.SAEE_Minute
        ) || this.minuteInfo.useSystemMinute === true
      );
    },
  },
  methods: {
    async validateMinute() {
      if (!this.isCompuMinuteSystemSelectionEnabled) return true;

      return this.hasMinuteAttached;
    },
    downloadFile(attachmentId) {
      return DocumentsService.downloadFromServer(attachmentId);
    },
    downloadDocument(documentTypeId, extension) {
      return DocumentsService.getDocumentByDocumentType(
        documentTypeId,
        extension
      );
    },
    async getABAEvaluationDocuments() {
      const { data } = await DocumentsService.getDocumentTypes(
        'ABAEvaluations'
      );
      this.documentTypes = data;
      this.documents = data.map((x) => ({
        file: null,
        documentTypeId: x.id,
        name: x.name,
      }));
    },
    onSelectFile(file, document) {
      document.file = file;
      this.$emit('input', this.documents);
    },
  },
};
</script>
<style>
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
</style>
